module.exports = __webpack_public_path__ + "static/media/bytt-no-2.e37a32c0.mp3";